<template>
  <div class="container">
    <div class="row">
      <!-- Social links -->
      <div class="col-12 col-md q-px-16">
        <div class="flex q-gutter-16">
          <a
            v-for="(social, key) in socials"
            :key="key"
            :href="social"
            target="_blank"
            class="aeroflot-social"
          ><q-icon :name="key" /></a>
        </div>
      </div>
      <!-- For customers links -->
      <div v-if="isAeroflotSubdomain" class="col-12 col-md q-mt-16 q-px-16">
        <div class="text-bold q-mb-8">{{ $t('domains.aeroflot.for_customers') }}</div>
        <div class="column fs-14">
          <a
            v-for="(link, key) in forCustomers"
            :key="key"
            :href="link"
            class="text-white q-pb-4"
          >
            {{ $t(`domains.aeroflot.${key}`) }}
          </a>
        </div>
      </div>
      <!-- For partners links -->
      <div v-if="isAeroflotSubdomain" class="col-12 col-md q-mt-16 q-px-16">
        <div class="text-bold q-mb-8">{{ $t('domains.aeroflot.for_partners') }}</div>
        <div class="column fs-14">
          <a
            v-for="(link, key) in forPartners"
            :key="key"
            :href="link"
            target="_blank"
            class="text-white q-pb-4"
          >
            {{ $t(`domains.aeroflot.${key}`) }}
          </a>
        </div>
      </div>
      <!-- Legal links -->
      <div class="col-12 col-md q-mt-16 q-px-16">
        <div class="column fs-14">
          <a
            v-for="(customer, key) in customers"
            :key="key"
            :href="customer"
            class="text-white q-pb-4"
          >
            {{ $t(`domains.aeroflot.${key}`) }}
          </a>
        </div>
        <div class="gt-sm flex q-mt-16 fs-14">
          <div class="q-pr-24">{{ $t('footer.address.header') }}:</div>
          <FooterAddressInfo />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';

import FooterAddressInfo from './FooterAddressInfo';
import { useConfigsStore } from '~stores/configs';

const { locale } = useI18n();
const configsStore = useConfigsStore();

// Client-side only check for subdomain
const isAeroflotSubdomain = ref(false);
onMounted(() => {
  isAeroflotSubdomain.value = typeof window !== 'undefined' && window.location.hostname.startsWith('aeroflot.');
});

const { configs } = storeToRefs(configsStore);

const socials = computed(() => ({
  vkontakte: 'https://vk.com/aeroflot',
  'youtube-play': 'https://www.youtube.com/user/AeroflotRussia/videos',
  weibo: 'http://www.weibo.com/aeroflotchina',
  wechat: 'http://mp.weixin.qq.com/s/rq7ZsLh626f15iNLCYWpYw',
}));

const forCustomers = computed(() => ({
  about_aeroflot: 'https://www.aeroflot.ru/ru-en/about',
  contact: 'https://www.aeroflot.ru/ru-en/about/contact',
  aeroflot_privacy_policy: 'https://www.aeroflot.ru/ru-en/information/legal/privacy_policy',
  anti_corruption: 'https://www.aeroflot.ru/ru-ru/about/anticorruption',
  cookie_policy: 'https://www.aeroflot.ru/ru-en/information/legal/cookie_policy',
  mobile_website: 'https://m.aeroflot.ru/ru-en',
  site_map: 'https://www.aeroflot.ru/ru-en/sitemap',
}));

const customers = computed(() => {
  const base = `${configs.value.base_url}/${locale.value}`;

  return {
    support: 'mailto:support@transfer-now.ru',
    faq: `${base}/faq`,
    terms_of_use: `${base}/terms_of_use`,
  };
});

const forPartners = computed(() => ({
  for_agents: 'https://www.aeroflot.ru/ru-en/company/for_agents',
  cargo: 'https://www.aeroflot.ru/xx-en/cargo_transport',
  aeroflot_group: 'https://www.aeroflot.ru/ru-en/about/subsidiaries',
  investors: 'https://ir.aeroflot.com/shareholders-and-investors/',
  skyteam: 'https://www.aeroflot.ru/ru-en/about/skyteam_alliance',
}));
</script>
